import React, {Component} from "react";

import "./MiniScaleLegend.css";

class MiniScaleLegend extends Component {

  render() {
    const {labelLess,labelMore,colors} = this.props;
    return (
      <div className="fow-mini-scale-legend">
        <span className="fow-mini-scale-legend-label fow-font-text fow-font-size-sm">{labelLess}</span>
        {colors.map((c,ix)=>
          <span key={`color-${ix}`} className="fow-mini-scale-legend-color" style={{backgroundColor:c}}></span>
        )}
        <span className="fow-mini-scale-legend-label fow-font-text fow-font-size-sm">{labelMore}</span>
      </div>
    );
  }
}

export default MiniScaleLegend;
